// extracted by mini-css-extract-plugin
export var headerOn = "Header-module--headerOn--kjR5i";
export var externalLink = "Header-module--externalLink--ID2u0";
export var internalLink = "Header-module--internalLink--OPgS2";
export var externalFluffy = "Header-module--externalFluffy--x49ws";
export var menuTrigger = "Header-module--menuTrigger--4oKFw";
export var activeMenu = "Header-module--activeMenu--TJaNO";
export var normalMenu = "Header-module--normalMenu--Y9pRw";
export var contactButton = "Header-module--contactButton--4QwCC";